import React from "react";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  makeStyles,
  colors,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

const useStyles = makeStyles(() => ({
  root: {},
}));

const Sales = ({ physics_macro,chemistry_macro,maths_macro,
biology_macro,mental_ability_macro,is_show_bio_ma,
classs,
   className, ...rest }) => {

  const classes = useStyles();
  const theme = useTheme();




  return (
    <Card  >
      <CardHeader
        // action={
        //   <Button endIcon={<ArrowDropDownIcon />} size="small" variant="text">
        //     Last 7 days
        //   </Button>
        // }
        title="Topicwise Analysis"
      />
      <Divider />
      <CardContent>
          <TopicTable classes={classes} subject="Physics" {...physics_macro} />
<br /><br />
<div className="pagebreak"></div>
          <TopicTable classes={classes} subject="Chemistry" {...chemistry_macro} />
<br /><br />
<div className="pagebreak"></div>
          <TopicTable classes={classes} subject="Mathematics" {...maths_macro} />
<br /><br />
<div className="pagebreak"></div>
        {is_show_bio_ma &&  <TopicTable classes={classes} subject="Biology" {...biology_macro} />}
<br /><br />
<div className="pagebreak"></div>
          {is_show_bio_ma && <TopicTable classes={classes} subject="Mental Ability" {...mental_ability_macro} />}
      </CardContent>
      <Divider />
    </Card>
  );
};


export default Sales;






const TopicTable=({classes,is_show_bio_ma,subject,topics,correct,incorrect,not_attempted,total})=>{
  return(
    <TableContainer >
    <Typography   variant="h6" id="tableTitle" component="div">
       {subject}
     </Typography>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Topic</TableCell>
            <TableCell  >Correct</TableCell>
            <TableCell  >Incorrect</TableCell>
            <TableCell  >Not Attempted</TableCell>
            <TableCell  >Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
{topics && topics.length>0 && topics.map((n,i)=>{

return(
     <TableRow  key={i}>
              <TableCell component="th" scope="row">
{n.topic}
              </TableCell>
              <TableCell  >{n.correct}</TableCell>
              <TableCell  >{n.incorrect} </TableCell>
              <TableCell  >{n.not_attempted} </TableCell>
              <TableCell  > {n.total}</TableCell>
            </TableRow>
          )
})}

<TableRow   >
         <TableCell component="th" scope="row">
<b>{"Total"}</b>
         </TableCell>
         <TableCell  ><b>{correct}</b></TableCell>
         <TableCell  ><b>{incorrect} </b></TableCell>
         <TableCell  ><b>{not_attempted}</b> </TableCell>
         <TableCell  ><b> {total}</b></TableCell>
       </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
